import { CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const ResponseTimeChartFallback = () => (
  <>
    <CardHeader className="pb-0 gap-0">
      <div className="flex w-full justify-between items-center">
        <div>
          <Skeleton className="h-7 w-50" />
        </div>
      </div>
    </CardHeader>
    <CardContent>
      <div className="h-60 w-full">
        <Skeleton className="h-full w-full" />
      </div>
    </CardContent>
  </>
)
